import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Collapse } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";

const JobInputSelectionComponent = ({
  options,
  handleCheckChange,
  selectedInputNames,
  label,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Function to handle click outside the component
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Form ref={ref}>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="default"
        style={{
          backgroundColor: "white",
          width: "100%",
          height: "50px",
          padding: "11.5px 10px",
          border: "0.4px solid lightgrey",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1rem",
            fontWeight: "360",
          }}
        >
          <span>
            {selectedInputNames.length !== 0 ? (
              <>
                {selectedInputNames.length === 1 ? (
                  <span> {selectedInputNames[0]} </span>
                ) : (
                  <span> ({selectedInputNames.length}) selected </span>
                )}
              </>
            ) : (
              <>Select {label}</>
            )}
          </span>
          <FaAngleDown
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0)", // Rotate the icon based on the dropdown state
              transition: "transform 0.3s ease-in-out", // Add transition for smooth animation
            }}
          />
        </div>
      </Button>
      <Collapse
        style={{
          position: "absolute",
          backgroundColor: "white",
          width: "230px",
          zIndex: 1,
        }}
        in={open}
      >
        <div id="example-collapse-text">
          <Form.Group controlId="exampleForm.SelectCustom">
            {options &&
              options.length !== 0 &&
              options.map((option) => {
                const name =
                  label === "Personas" ? option?.persona?.name : option?.name;
                return (
                  <Form.Check
                    style={{ fontSize: "0.85rem", fontWeight: "600" }}
                    key={option.id}
                    type="checkbox"
                    label={name}
                    className={`mb-2 customData`}
                    checked={selectedInputNames.includes(name)}
                    onChange={(event) => handleCheckChange(name)}
                  />
                );
              })}
          </Form.Group>
        </div>
      </Collapse>
    </Form>
  );
};

export default JobInputSelectionComponent;
